import Splide from "@splidejs/splide";

export default () => {
  const gridCarousels =
    document.querySelectorAll<HTMLElement>(".js-grid-carousel");

  gridCarousels.forEach(($el: HTMLElement) => {
    const perPage = parseInt($el.dataset.cols ?? "4", 0);
    new Splide($el, {
      gap: 32,
      perPage: perPage,
      breakpoints: {
        768: { perPage: 1 },
        1024: { perPage: perPage === 3 ? 1 : perPage > 1 ? 2 : 1 },
        1280: { perPage: perPage === 3 ? 3 : perPage > 1 ? 2 : 1 },
      },
    }).mount();
  });
};
